export const BRAND = {
  name: "Hillory",
  logoPath: "/hillory/logo-nav.svg",
  iconPrefix: "/hillory",
  domain: "hillory.run",
  supportEmail: "ollie@hillory.run",
  privacyEmail: "ollie@hillory.run",
  themeColor: "#059669",
  metaDescription:
    "Periodised strength training for trail runners. Fatigue-aware sessions that adapt to your readiness. Free during beta.",
  footerDisclaimer: "Hillory provides trail running training suggestions and educational content.",
  healthDisclaimer:
    "Hillory provides trail running training suggestions and educational content. All sessions, distances, and pacing are suggestions — you always decide what feels right for you.",
  activityRiskDescription:
    "Trail running, like all physical exercise, carries inherent risks including muscle strains, joint injuries, and cardiovascular events. You are responsible for choosing appropriate distances and effort levels for your fitness level.",
  sisterBrandName: "Load & Flow",
  sisterDomain: "loadandflow.com",
  sisterTagline: "Smart Strength Training",
} as const;
